<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-1">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="mb-2 text-primary">محصولات</h3>
                <div class="d-flex align-items-center mb-2">
                    <b-button :disabled="!categoriesData.length" @click="showModalProductsGroupEditing"
                        class="d-flex align-items-center mr-1 px-1" variant="info">
                        ویرایش گروهی
                    </b-button>
                    <b-button :disabled="!categoriesData.length" @click="showModalAddProduct"
                        class="d-flex align-items-center px-1" variant="primary">
                        اضافه کردن
                    </b-button>
                </div>
            </div>
            <b-row v-if="categoriesData.length">
                <b-col lg="5" md="4">
                    <div>
                        <h5 class="mb-50">انتخاب دسته</h5>
                        <b-card no-body class="mb-1">
                            <v-select v-model="categoryId" :searchable="false" dir="rtl" :options="categoriesData"
                                :reduce="(value) => value.id" label="name_Fa" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-card>
                    </div>
                </b-col>
                <b-col lg="5" md="4">
                    <div>
                        <h5 class="mb-50">انتخاب زیردسته</h5>
                        <b-card no-body class="mb-1">
                            <v-select v-model="subCategoryId" :searchable="false" dir="rtl"
                                :options="categoryData.subCategories" :reduce="(value) => value.id" label="name_Fa">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-card>
                    </div>
                </b-col>
                <b-col lg="2" md="4">
                    <div>
                        <h5 class="mb-50">تغییر ترتیب نمایش</h5>
                        <b-card no-body class="mb-1">
                            <v-select v-model="changeProductDisplay" :searchable="false" :clearable="false" dir="rtl"
                                :options="changeProductDisplayData" :reduce="(value) => value.id" label="name">
                            </v-select>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
            <div v-if="!loading">
                <b-row v-if="productsData.length">
                    <draggable v-model="productsData" class="d-flex flex-wrap w-100" tag="div" :animation="300"
                        :disabled="!changeProductDisplay" handle="#product_drag_handle" ghost-class="ghost-card"
                        @end="onDragEnd">
                        <transition-group type="transition" name="flip-list" class="d-flex flex-wrap w-100">
                            <b-col v-for="(item, index) in productsData" :key="item.id" xl="6">
                                <b-card class="product-item mb-1 mt-75" no-body
                                    :class="{ 'product-box-shadow': item.isSpecial }">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="d-flex align-items-center">
                                            <div id="product_drag_handle" class="position-relative"
                                                style="width: 90px;height: 90px;"
                                                :style="{ cursor: changeProductDisplay ? 'grab' : 'default' }">
                                                <img v-if="item.imagePath" :src="BASE_URL_File + item.imagePath"
                                                    class="w-100 h-100 rounded object-fit-cover">
                                                <img v-if="!item.imagePath" src="@/assets/images/pages/default.jpg"
                                                    class="w-100 h-100 rounded object-fit-cover">
                                                <div v-if="!item.newContentsAccepted"
                                                    class="position-absolute d-flex justify-content-center align-items-center w-100 h-100 user-select-none rounded"
                                                    style="top: 0;background-color: rgba(0, 0, 0, 0.6);">
                                                    <div class="text-warning font-weight-bolder"
                                                        style="font-size: 13px;">
                                                        در حال بررسی
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="py-1 pl-1">
                                                <h4 class="text-overflow-ellipsis  name-product-width pb-50">
                                                    {{ item.name_Fa }}
                                                </h4>
                                                <div class="d-flex align-items-center">
                                                    <h6 class="display-order-title text-muted mb-0">
                                                        ترتیب نمایش: {{ item.order }}
                                                    </h6>
                                                    <span class="display-order-title mx-50">-</span>
                                                    <h6 class="mb-0"
                                                        :class="item.isActive ? 'text-info' : 'text-warning'">
                                                        {{ item.isActive ? 'فعال' : 'غیر فعال' }}
                                                    </h6>
                                                    <span class="mx-50">-</span>
                                                    <h6 class="mb-0"
                                                        :class="item.isAvailable ? 'text-success' : 'text-danger'">
                                                        {{ item.isAvailable ? 'موجود' : 'ناموجود' }}
                                                    </h6>
                                                    <span class="mx-50">-</span>
                                                    <h6 class="mb-0"
                                                        :class="item.showInMenu ? 'text-info' : 'text-warning'">
                                                        {{ item.showInMenu ? 'نمایش' : 'عدم نمایش' }}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="py-1 pr-75">
                                            <b-dropdown id="dropdown-bill" dropdown left variant="link" no-caret
                                                :no-flip="index === 0" toggle-class="p-0 m-0">
                                                <template #button-content>
                                                    <feather-icon icon="MoreVerticalIcon" size="22"
                                                        class="text-primary" />
                                                </template>
                                                <b-dropdown-item @click="changeAvailableStatus(item)">
                                                    <div class="d-flex align-items-center">
                                                        <feather-icon icon="RotateCwIcon" size="18" />
                                                        <span class="ml-50"> {{ item.isAvailable ? 'ناموجود' :
                                                            'موجود' }}</span>
                                                    </div>
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="changeSpecialStatusProduct(item)">
                                                    <div class="d-flex align-items-center">
                                                        <feather-icon icon="RotateCwIcon" size="18" />
                                                        <span class="ml-50">{{ item.isSpecial ? 'غیر متمایز' :
                                                            'متمایز'
                                                        }}</span>
                                                    </div>
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="showModalEditProduct(item.id)">
                                                    <div class="d-flex align-items-center">
                                                        <feather-icon icon="EditIcon" size="18" />
                                                        <span class="ml-50">ویرایش</span>
                                                    </div>
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="changeActiveStatus(item)">
                                                    <div class="d-flex align-items-center">
                                                        <feather-icon icon="RotateCwIcon" size="18" />
                                                        <span class="ml-50"> {{ item.isActive ? 'غیر فعال' : 'فعال'
                                                        }}</span>
                                                    </div>
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="changeShowInMenu(item)">
                                                    <div class="d-flex align-items-center">
                                                        <feather-icon :icon="item.showInMenu ? 'EyeOffIcon' : 'EyeIcon'"
                                                            size="18" />
                                                        <span class="ml-50">
                                                            {{ item.showInMenu ? 'عدم نمایش در منو' : 'نمایش در منو'
                                                            }}
                                                        </span>
                                                    </div>
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="showModalDeleteProduct(item.id)">
                                                    <div class="d-flex align-items-center">
                                                        <feather-icon icon="Trash2Icon" size="18" />
                                                        <span class="ml-50">حذف</span>
                                                    </div>
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </div>
                                </b-card>
                                <!-------------------------------------- edit modal -------------------------------------->
                                <b-modal :id="`modal-edit-product${item.id}`" title="ویرایش محصول" size="xl" centered
                                    :hide-footer="true" title-class="font-weight-bolder">
                                    <b-card-text>
                                        <EditProduct @editProduct="editProduct(item.id)" :data="item"
                                            :categoriesData="categoriesData" :categoryId="categoryId"
                                            :materials="materials" :warehouses="warehouses" />
                                    </b-card-text>
                                </b-modal>
                                <!-------------------------------------- delete modal -------------------------------------->
                                <b-modal :id="`modal-delete-product${item.id}`" title="حذف محصول" centered
                                    :hide-footer="true" title-class="font-weight-bolder">
                                    <b-card-text class="p-1">
                                        <h5 class="text-center text-danger mb-3">آیا از حذف این محصول مطمئن هستید؟</h5>
                                        <div class="d-flex align-items-center">
                                            <b-button @click="$bvModal.hide(`modal-delete-product${item.id}`)"
                                                class="w-50 mr-1" variant="secondary">
                                                انصراف
                                            </b-button>
                                            <b-button :disabled="loadingDelete"
                                                @click="deleteProduct(item.id, `modal-delete-product${item.id}`)"
                                                class="w-50" variant="danger">
                                                حذف
                                            </b-button>
                                        </div>
                                    </b-card-text>
                                </b-modal>
                            </b-col>
                        </transition-group>
                    </draggable>
                </b-row>
                <h5 v-if="!productsData.length" class="d-flex align-items-center justify-content-center"
                    :style="noCase">
                    موردی وجود ندارد
                </h5>
            </div>

            <!------------------------------- loading ------------------------------->
            <div v-if="loading">
                <loading :minHeight="46" />
            </div>
            <!------------------------------- modal add product ------------------------------->
            <b-modal id="modal-add-product" title="اضافه کردن محصول" size="xl" centered :hide-footer="true"
                title-class="font-weight-bolder">
                <AddProduct @addProduct="addProduct" :categoriesData="categoriesData" :materials="materials"
                    :warehouses="warehouses" />
            </b-modal>
        </div>


        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormInput, BFormFile, BTable, BPagination, BDropdown, BDropdownItem, BDropdownItemButton } from 'bootstrap-vue';
import AddProduct from '@/@core/components/product/add.vue';
import EditProduct from '@/@core/components/product/edit.vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';
import { accessHandling } from '@core/mixins/accessHandling';
import draggable from 'vuedraggable'

export default {
    components: {
        BPagination,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormInput,
        BFormFile,
        BTable,
        BDropdownItem,
        BDropdown,
        EditProduct,
        BDropdownItemButton,
        AddProduct,
        vSelect,
        draggable
    },
    computed: {
        noCase() {
            return !this.categoryId ? { minHeight: '60vh' } : { minHeight: '46vh' };
        },
    },
    mixins: [accessHandling],
    data() {
        return {
            loading: true,
            loadingDelete: false,
            loadingPage: false,
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            isAdminIdentityVerified: false,
            storeId: null,
            productsData: [],
            categoriesData: [],
            categoryId: null,
            materials: [],
            warehouses: [],
            parameters: {
                pageIndex: 1,
                pageSize: 90,
            },
            categoryData: null,
            subCategoryId: null,
            changeProductDisplay: false,
            changeProductDisplayData: [
                { id: false, name: 'غیرفعال' },
                { id: true, name: 'فعال' },
            ]
        }
    },
    watch: {
        categoryId() {
            this.subCategoryId = null
            this.categoriesData.forEach(item => {
                if (item.id == this.categoryId) {
                    this.categoryData = item
                }
            });
            this.getProduct();
        },
        changeProductDisplay(newVal, oldVal) {
            if (newVal === true && oldVal === false) {
                if (!this.accessHandling('employee', 'categories_products_order_change')) {
                    this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
                    this.$nextTick(() => {
                        this.changeProductDisplay = false;
                    });
                }
            }
        },
        subCategoryId() {
            this.getProduct();
        },
    },
    methods: {
        onDragEnd() {
            this.changeOrder();
        },
        showModalAddProduct() {
            if (this.accessHandling('employee', 'categories_products_create')) {
                this.$bvModal.show('modal-add-product');
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        deleteProduct(id, modal) {
            this.loadingDelete = true;
            storeService.deleteProduct(this.storeId, id).then(({ data }) => {
                this.$notif({ type: 'success', title: 'محصول با موفقیت حذف شد' });
                this.loadingDelete = false;
                this.getProduct();
            })
                .catch((err) => {
                    this.$bvModal.hide(modal)
                    this.loadingDelete = false;
                })
        },
        getCategory() {
            storeService.getCategory(this.storeId).then(({ data }) => {
                this.categoriesData = data
                if (this.categoriesData.length) {
                    this.categoryId = this.categoriesData[0].id
                    this.categoryData = this.categoriesData[0]
                }
                else {
                    this.loading = false;
                }
            })
        },
        getProduct() {
            this.loading = true;
            let id = null
            if (this.subCategoryId) {
                id = this.subCategoryId
            }
            else {
                id = this.categoryId
            }
            storeService.getProduct(this.storeId, id).then(({ data }) => {
                this.productsData = data
                this.loading = false;
            })
        },
        addProduct() {
            this.$bvModal.hide('modal-add-product');
            this.getProduct();
        },
        editProduct(itemId) {
            this.$bvModal.hide(`modal-edit-product${itemId}`);
            this.getProduct();
        },
        changeActiveStatus(item) {
            if (this.accessHandling('employee', 'categories_products_status_change')) {
                storeService.changeActiveStatusProduct(this.storeId, item.id, { isActive: !item.isActive }).then(({ data }) => {
                    this.$notif({ type: 'success' });
                    item.isActive = !item.isActive
                })
                    .catch((err) => {
                        this.$notif({ type: 'error' });
                    })
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        changeShowInMenu(item) {
            if (this.accessHandling('employee', 'categories_products_status_change')) {
                storeService.changeShowInMenuProduct(this.storeId, item.id, { showInMenu: !item.showInMenu }).then(({ data }) => {
                    this.$notif({ type: 'success' });
                    item.showInMenu = !item.showInMenu
                })
                    .catch((err) => {
                        this.$notif({ type: 'error' });
                    })
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalEditProduct(itemId) {
            if (this.accessHandling('employee', 'categories_products_edit')) {
                this.$bvModal.show(`modal-edit-product${itemId}`)
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalDeleteProduct(itemId) {
            if (this.accessHandling('employee', 'categories_products_delete')) {
                this.$bvModal.show(`modal-delete-product${itemId}`)
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalProductsGroupEditing() {
            if (this.accessHandling('employee', 'update_products_batch')) {
                this.$router.push('/products/group-editing')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        changeSpecialStatusProduct(item) {
            if (this.accessHandling('employee', 'products_special_status_change')) {
                storeService.changeSpecialStatusProduct(this.storeId, { isSpecial: !item.isSpecial, ids: [item.id] }).then(({ data }) => {
                    this.$notif({ type: 'success' });
                    item.isSpecial = !item.isSpecial
                })
                    .catch((err) => {
                        this.$notif({ type: 'error' });
                    })
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        changeAvailableStatus(item) {
            if (this.accessHandling('employee', 'products_availability_status_change')) {
                storeService.changeAvailableStatusProduct(this.storeId, { isAvailable: !item.isAvailable, ids: [item.id] }).then(({ data }) => {
                    this.$notif({ type: 'success' });
                    item.isAvailable = !item.isAvailable
                })
                    .catch((err) => {
                        this.$notif({ type: 'error' });
                    })
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        changeOrder() {
            let categoryIdToSend = this.subCategoryId ? this.subCategoryId : this.categoryId;
            let productIdsInOrder = this.productsData.map(item => item.id);
            let payload = {
                categoryId: categoryIdToSend,
                productIdsInOrder: productIdsInOrder
            };
            storeService.changeOrderProduct(this.storeId, payload).then(({ data }) => {
                this.$notif({ type: 'success', title: 'تغییر ترتیب نمایش با موفقیت انجام شد' });

            })
                .catch((err) => {
                    this.getProduct();
                })
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                this.loadingPage = false;
                if (this.isAdminIdentityVerified) {
                    if (this.accessHandling('subscription', 3) && this.accessHandling('employee', 'categories_products_create', 'categories_products_edit')) {
                        this.getWarehousingMaterials()
                    }
                    else {
                        this.getCategory();
                    }
                }
            })
        },
        getWarehousingMaterials() {
            storeService.warehousingMaterialsForProducts(this.storeId).then(({ data }) => {
                this.materials = data.items
                this.getWarehousingWarehouses();
            })
        },
        getWarehousingWarehouses() {
            storeService.getWarehousingWarehouses(this.storeId, this.parameters).then(({ data }) => {
                this.warehouses = data.items
                this.getCategory();
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCompletionStatus();
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.product-item {
    border: 2px solid #ffffff00;
}

.name-product-width {
    width: 26vw;


    @media (max-width: 1500px) {
        width: 23vw;
    }

    @media (max-width: 1370px) {
        width: 21vw;
    }

    @media (max-width: 1300px) {
        width: 30vw;
    }

    @media (max-width: 1200px) {
        width: 70vw;
    }

    @media (max-width: 767px) {
        width: 40vw;
    }

    @media (max-width: 330px) {
        width: 33vw;
    }
}

.product-box-shadow {
    box-shadow: #576fbd 0px 0px 12px, rgba(0, 0, 0, 0.30) 0px 0px 6px !important;
}

.user-select-none {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.display-order-title {
    @media (max-width: 430px) {
        display: none;
    }
}

.ghost-card {
    opacity: 0.4;
}
</style>